module.exports = __webpack_public_path__ + "static/img/1.a0618f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/eng/1.png
// module id = qtLY
// module chunks = 0